import { createFileRoute } from '@tanstack/react-router';
import { RequireMeasurements } from '../components/RequireMeasurements.js';
import { ReviewStep } from '../steps/ReviewStep.js';

export const Route = createFileRoute('/_planner/planner/review')({
  component: () => (
    <RequireMeasurements requireLock currentIndex={4} allowUnavailableCatalogue>
      <ReviewStep />
    </RequireMeasurements>
  ),
});
